import { useTheme } from '@/providers/theme/use-theme';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Outlet, useLocation } from 'react-router-dom';
import { InstallAppDialog } from '../enc/install-app-dialog';
import { AppSidebar } from '../ui/app-sidebar';
import { AppTopbar } from '../ui/app-topbar';

/** O tema escuro vale só para o admin — o site público é sempre claro. */
function useAdminTheme() {
  const { theme } = useTheme();

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('dark', theme === 'dark');
    return () => root.classList.remove('dark');
  }, [theme]);
}

/** Torna só o /admin instalável (PWA); o site público não carrega o manifest. */
function useAdminPwa() {
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/admin-sw.js', { scope: '/admin' })
        .catch(() => undefined);
    }
  }, []);
}

export function AppLayout() {
  useAdminTheme();
  useAdminPwa();
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => setMenuOpen(false), [pathname]);

  return (
    <div className="flex min-h-screen bg-bg text-body">
      <Helmet>
        <link rel="manifest" href="/admin.webmanifest" />
        <link rel="apple-touch-icon" href="/assets/icons/admin-192.png" />
        <meta name="theme-color" content="#A5262C" />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <InstallAppDialog />
      <AppSidebar open={menuOpen} onNavigate={() => setMenuOpen(false)} />
      {menuOpen && (
        <div
          onClick={() => setMenuOpen(false)}
          className="fixed inset-0 z-30 hidden bg-black/40 max-[999px]:block"
        />
      )}
      <main className="flex min-w-0 flex-1 flex-col">
        <AppTopbar onOpenMenu={() => setMenuOpen(true)} />
        <div className="flex w-full flex-col gap-5 px-7 pt-8 pb-16 max-sm:px-4">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
